import React from "react";
import { Outlet } from "react-router-dom";
import CommonLayout from "../../pages/Layouts/CommonLayout";
import useCustomers from "./useCustomers";

const Customers = () => {
  const { drawerMenu } = useCustomers();
  return (
    <CommonLayout drawerMenu={drawerMenu} className={`customers`}>
      <Outlet />
    </CommonLayout>
  );
};

export default Customers;
